module.exports = __webpack_public_path__ + "img/prayer.8e9b8f6d.png";